// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3SBB3","col":"Table_col__7Q76s","fulfillmentStatus":"Table_fulfillmentStatus__2h4m0","emailCol":"Table_emailCol__1vwaz"};